import React from 'react';
import PropTypes from 'prop-types';

// classnames
import classNames from 'classnames';

import TradeInItem from './trade-in-item/TradeInItem';

import styles from './trade-in-details.scss';

const TradeInDetails = ({
  handleRemoveItem,
  hideItemRemoveOverlay,
  isModalView,
  isProcessing,
  showItemRemoveOverlay,
  showTradeInBoxInOrderConfirmation,
  tradeInItems,
}) => {

  if (!tradeInItems.length) {
    return null;
  }

  const containerClassNames = classNames(styles.tradeInItemsContainer, {
    [styles.modalView]: isModalView,
  });

  return (
    <div className={containerClassNames} data-test="trade-in-items-container">
      {tradeInItems.map((item, ind) => (
        <TradeInItem
          key={`trade-in-item-${ind + 1}`}
          handleRemoveItem={handleRemoveItem}
          hideItemRemoveOverlay={hideItemRemoveOverlay}
          index={ind}
          isModalView={isModalView}
          isProcessing={isProcessing}
          itemId={item.id}
          itemName={item.deviceName}
          itemPaymentAmount={item.payment?.amount}
          itemPaymentType={item.payment?.type}
          showItemRemoveOverlay={showItemRemoveOverlay}
          showTradeInBoxInOrderConfirmation={showTradeInBoxInOrderConfirmation}
        />
      ))}
    </div>
  );
};

TradeInDetails.propTypes = {
  handleRemoveItem: PropTypes.func,
  hideItemRemoveOverlay: PropTypes.func,
  isModalView: PropTypes.bool,
  isProcessing: PropTypes.bool,
  showItemRemoveOverlay: PropTypes.func,
  showTradeInBoxInOrderConfirmation: PropTypes.bool,
  tradeInItems: PropTypes.arrayOf(PropTypes.shape({
    deviceName: PropTypes.string,
    id: PropTypes.string,
    payment: PropTypes.shape({
      amount: PropTypes.string,
    }),
  })),
};

TradeInDetails.defaultProps = {
  handleRemoveItem: () => {},
  hideItemRemoveOverlay: () => {},
  isModalView: false,
  isProcessing: false,
  showItemRemoveOverlay: () => {},
  showTradeInBoxInOrderConfirmation: false,
  tradeInItems: [],
};

export default TradeInDetails;
